module.exports = __webpack_public_path__ + "static/media/Lucky-Spins-Two-Lines-Pattern-Yellow-600x600.0cdb8e20.png";